import gql from 'graphql-tag'

/**
 * Query
 */
const GET_WITH_PAGINATION = gql`
    query positionsWithPagination($page: Int, $perPage: Int) {
        positionsWithPagination(page: $page, first: $perPage){
            paginatorInfo {
                currentPage
                count
                hasMorePages
                perPage
                total
            }
            data {
                id
                name
                description
                is_active
                status_text
            }
        }
    }
`

const ALL_ACTIVE = gql`
    query positionsActive {
        positionsActive {
            id
            name
            description
            status_text
            is_active
        }
    }
`

/**
 * Mutations
 */
const CHANGE_STATUS = gql`
    mutation updatePosition ($id: ID!, $status: Boolean) {
        updatePosition (id: $id, input: {
            is_active: $status
        }) {
            id
            is_active
            status_text
        }
    }
`

const SAVE = gql`
    mutation createPosition ($input: PositionInput!) {
        createPosition (input: $input) {
            name
            description
            id
            is_active
        }
    }
`

const UPDATE = gql`
    mutation updatePosition ($id: ID!, $input: PositionUpdateInput!) {
        updatePosition (id: $id, input: $input) {
            name
            description
            id
            is_active
        }
    }
`

const DELETE = gql`
    mutation deletePosition ($id: ID!) {
        deletePosition(id: $id) { 
            id
        }
    }
`

export {
    GET_WITH_PAGINATION,
    CHANGE_STATUS,
    SAVE,
    UPDATE,
    DELETE,
    ALL_ACTIVE
}
